import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "-mx-6 w-[calc(100%+32px)] pb-6"
}
const _hoisted_2 = { class: "mx-6 mt-8 border rounded-lg border-neutral-100" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex space-x-2" }
const _hoisted_5 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Report Type", -1)
const _hoisted_7 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_8 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "CASE RELATED", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_11 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "LOCATION RELATED", -1)
const _hoisted_13 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Group", -1)
const _hoisted_15 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_16 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "CATEGORY", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Filter", -1)
const _hoisted_19 = { class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-neutral-900" }, "Sort", -1)
const _hoisted_21 = { class: "p-6 overflow-hidden bg-white rounded-lg shadow-md ring-1 ring-black/5 sort" }
const _hoisted_22 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_24 = { class: "flex flex-col w-auto space-y-2 bg-white" }
const _hoisted_25 = { class: "space-y-5" }
const _hoisted_26 = { class: "space-y-5" }
const _hoisted_27 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_28 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_29 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_30 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_31 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_32 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_33 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_34 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_35 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_36 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_37 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_38 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_39 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_40 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_41 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_42 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_43 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_44 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_45 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_46 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_47 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_48 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_49 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_50 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_51 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_52 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_53 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_54 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_55 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_56 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_57 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_58 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_59 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_60 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_61 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_62 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_63 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_64 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_65 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_66 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_67 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_68 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_69 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_70 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_71 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_72 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_73 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_74 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_75 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_76 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_77 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_78 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_79 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_80 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_81 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_82 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_83 = { class: "bg-gray-50" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }, " Total ", -1)
const _hoisted_85 = { class: "w-full px-6 border-t py-7" }

import { onMounted, ref, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import DetailTable from '@/components/partials/DetailTable.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { AdjustmentsVerticalIcon, UserGroupIcon, FunnelIcon, ArrowsUpDownIcon } from "@heroicons/vue/24/outline";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import ReportService from "@/classes/Reports/ReportService";
import MultiSelect from '@/components/inputs/MultiSelect.vue';
import DateFormatter from '@/helpers/DateFormatter';
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import { ReportTypes } from '@/views/enums/ReportTypes';
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface";
import DropdownService from "@/classes/Dropdowns/DropdownService";
import { PrimaryDiagnosisReportTypes } from '@/views/enums/PrimaryDiagnosisReportTypes';
import ReportTypeDiagnosis from '@/enums/Reports/ReportTypeDiagnosis';
import { RoleTypes } from '@/views/enums/RoleTypes';

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPrimaryDiagnosisRelated',
  setup(__props) {

const regions = ref<renderSelect[]>([]);
const cities = ref<renderSelect[]>([]);
const provinces = ref<renderSelect[]>([]);
const barangays = ref<renderSelect[]>([]);

const diagnosis = ref<renderSelect[]>([]);
const offices = ref<renderSelect[]>([]);
const showFilter = ref<boolean>(false); 
const loading = ref<boolean>(false);
const userData = ref(null);

const filters = ref({
    rows: 10,
    query: null,
    report_type: PrimaryDiagnosisReportTypes.SUICIDAL_RISK,  
    created_at: null,
    column: 'name',
    order: 'ASC',
    page: 1,
    group_category: 1,

    //filters for report
    region_id: null,
    province_id: null,
    city_id: null,
    barangay_id: null,

    //filter the primary diagnosis
    diagnosis_id:  null,

    // others
    registered_at: null,
    office_id: null,
}) 
const sampleOptions = [
    { id: '1', label: 'Label', value: 'name'},
    { id: '2', label: 'Count', value: 'total'},
]

const defaultOptions = [
    { id: '3', label: 'Ascending', value: 'ASC'},
    { id: '4', label: 'Descending', value: 'DESC'},
]
   
const reportTypeOptions = [
    { id: "9", label: "Region", value: PrimaryDiagnosisReportTypes.REGION },
    { id: "8", label: "Province", value: PrimaryDiagnosisReportTypes.PROVINCE },
    { id: "7", label: "City", value: PrimaryDiagnosisReportTypes.CITY },
    { id: "6", label: "Barangay", value: PrimaryDiagnosisReportTypes.BARANGAY },
    { id: "10", label: "Office", value: PrimaryDiagnosisReportTypes.OFFICE },
     
];
    
const reportTypePatientOptions = [
    // { id: "5", label: "COMORBID", value: PrimaryDiagnosisReportTypes.COMORBID }, 
];

const reportTypeCaseOptions = [
    { id: "1", label: "Suicidal Risk", value: PrimaryDiagnosisReportTypes.SUICIDAL_RISK },
    { id: "2", label: "Perpetrator Relation", value: PrimaryDiagnosisReportTypes.PERPETRATOR_RELATION },
    { id: "3", label: "Referral Source", value: PrimaryDiagnosisReportTypes.REFERRAL_SOURCE },
    { id: "4", label: "PWD", value: PrimaryDiagnosisReportTypes.PWD },
];
 
const vacHeader = ref([
    { text: 'Report Type', colspan: 1, rowspan: 2, }, 
    { text: '0-3', colspan: 2, rowspan: 1,  subheaders: ['M', 'F']  },
    { text: '4-6', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '7-9', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '10-12', colspan: 2, rowspan: 1,subheaders: ['M', 'F'] },
    { text: '13-15', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '16-18', colspan: 2, rowspan: 1,subheaders: ['M', 'F'] },
    { text: 'Total', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: 'Children', colspan: 1, rowspan: 2,},//Total Children 
])


const vawHeader = ref([
    { text: 'Report Type', colspan: 1, rowspan: 2, }, 
    { text: '19-24', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '25-44', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '45-59', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '60-Above', colspan: 2, rowspan: 1, subheaders: ['M', 'F']}, 
    { text: 'Total', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: 'Women', colspan: 1, rowspan: 2},//Total Women 
])

const defaultHeader = ref([
    { text: 'Report Type', colspan: 1, rowspan: 1, subheaders: ['primary diagnosis']}, 
    { text: '0-3', colspan: 2, rowspan: 1,  subheaders: ['M', 'F']  },
    { text: '4-6', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '7-9', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '10-12', colspan: 2, rowspan: 1,subheaders: ['M', 'F'] },
    { text: '13-15', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '16-18', colspan: 2, rowspan: 1,subheaders: ['M', 'F'] },
    { text: 'Total', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: 'Children', colspan: 1, rowspan: 2,},//Total Children
     
    { text: '19-24', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '25-44', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '45-59', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: '60-Above', colspan: 2, rowspan: 1, subheaders: ['M', 'F']}, 
    { text: 'Total', colspan: 2, rowspan: 1, subheaders: ['M', 'F']},
    { text: 'Women', colspan: 1, rowspan: 2},//Total Women
    { text: 'Grand Total', colspan: 1, rowspan: 2 },//Grand Total
]);

const items = ref()
const totals = ref()

const defaultCategoryOptions = [
    { id: "1", label: "CPN/Children", value: 1 }, 
    { id: "3", label: "Adult Patient", value: 3 },
];

 
const paginate = ( page:number, rows:number )=>{
    ReportService.paginate(page, rows,filters.value, getData)
}

const applyFilters = (search: any = null) => {
	showFilter.value = false; 
    paginate( 1, filters.value.rows);   
};

const applyReset = () => {
    showFilter.value = false;
    filters.value.created_at = null; 
    filters.value.region_id = null;
    filters.value.province_id  = null;
    filters.value.city_id = null;   
    filters.value.barangay_id = null;
    filters.value.diagnosis_id =null;
    paginate( 1, filters.value.rows);
};
 
const getData = () => {  
    loading.value = true;
    ReportService.index('primary-diagnosis-related', omitBy(filters.value, isNil))
        .then(({ data }) => {  
            items.value = data.items.data; 
            totals.value = data.items.totals;  
            diagnosis.value = data.diagnosis;
            offices.value = data.offices;
        })
        .catch(errors => { 
            console.log(errors);
        })
        .finally(() => loading.value = false)
}

const exporting = (): void => { 
    loading.value = true;   
    ReportService.export('primary-diagnosis-related',omitBy(filters.value, isNil))
        .then(({data})=>{
             ReportService.downloadExport("primary-diagnosis-export.csv",data);  
        })
        .finally(() => loading.value = false)
}

const getRegions = async (): Promise<any> => { 
    DropdownService
    .regions()
    .then(({data}) => {
        regions.value = data;
    }) 
}

 
const getProvince = async (): Promise<any> => {
    if(filters.value.region_id){ 
        DropdownService
        .provinces(filters.value.region_id)
        .then(({data}) => {
            provinces.value = data;
        }) 
    }
}

const getCity = async (): Promise<any> => {
    if(filters.value.province_id){ 
        DropdownService
        .cities(filters.value.province_id)
        .then(({data}) => {
            cities.value = data;
        }) 
    }
}

const getBrangay = async (): Promise<any> => { 
    if(filters.value.city_id){ 
        DropdownService
        .barangays(filters.value.city_id)
        .then(({data}) => {
            barangays.value = data;
        }) 
    }
}
const regionChange = ():void => {
    filters.value.city_id = null
    filters.value.barangay_id = null
    filters.value.province_id = null 
    getProvince()
}

const provinceChange = ():void => {
    filters.value.city_id = null
    filters.value.barangay_id = null
    getCity()
}

const cityChange = ():void => { 
    filters.value.barangay_id = null 
    getBrangay()
}
//----------------------------------------
 
const getDiagnosisHeader = (type: any) =>{  
    defaultHeader.value[0].subheaders[0] = 'All'; 
    diagnosis.value.filter(function(item:any){ 
        if(item.value === type){ 
            defaultHeader.value[0].subheaders[0] = item.label 
        } 
    });     
}

const getReportTypeHeader = (type: any)=>{ 
    defaultHeader.value[0].text = ReportTypeDiagnosis[0].label;
    ReportTypeDiagnosis.filter(function(item):any{
        if(item.value === type){
            defaultHeader.value[0].text = item.label;
        }
    })
} 

watch(
    () => filters.value.report_type,
    debounce(() => {   
        applyReset();
    }, 500)
) 
watch(
    () => filters.value.diagnosis_id,
    debounce(() => {    
        getDiagnosisHeader(filters.value.diagnosis_id);   
    }, 500)
);

watch(
    () => filters.value.report_type,
    debounce(() => { 
        getReportTypeHeader(filters.value.report_type);   
    }, 500)
);

watch(
    () => filters.value.query,
    debounce(() => {
        paginate( 1, filters.value.rows);
        applyReset();
    }, 500)
);
 
onMounted(() => { 
    getRegions(),
    getData(), 
    getReportTypeHeader(1); 
    getDiagnosisHeader(1);

    userData.value =  JSON.parse(localStorage.getItem('user'));
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Primary Diagnosis Related Reports",
    backLink: "/reports"
  }, {
    lowerRight: _withCtx(() => [
      _createVNode(ExportButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (exporting()))
      })
    ]),
    default: _withCtx(() => [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(DetailTable, {
                  hasSearch: true,
                  searchPlaceholder: "Search Report type name",
                  headers: 
                        filters.value.report_type !== _unref(PrimaryDiagnosisReportTypes).COMORBID ? defaultHeader.value
                        : (filters.value.group_category == 1 ? vacHeader.value : vawHeader.value)
                        ,
                  "no-action": true,
                  count: items.value?.data?.length,
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  search: filters.value.query,
                  "onUpdate:searchText": _cache[25] || (_cache[25] = (value) => (filters.value.query = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(AdjustmentsVerticalIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_6
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                      _hoisted_9,
                                      _createVNode(RadioGroup, {
                                        options: reportTypeCaseOptions,
                                        name: "reportTypeCaseOptions",
                                        customLabelClass: "whitespace-nowrap",
                                        modelValue: filters.value.report_type,
                                        "onUpdate:modelValue": [
                                          _cache[1] || (_cache[1] = ($event: any) => ((filters.value.report_type) = $event)),
                                          _cache[2] || (_cache[2] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_10,
                                    _createElementVNode("div", _hoisted_11, [
                                      _hoisted_12,
                                      _createVNode(RadioGroup, {
                                        options: reportTypeOptions,
                                        name: "reportTypeOptions",
                                        customLabelClass: "whitespace-nowrap",
                                        modelValue: filters.value.report_type,
                                        "onUpdate:modelValue": [
                                          _cache[3] || (_cache[3] = ($event: any) => ((filters.value.report_type) = $event)),
                                          _cache[4] || (_cache[4] = ($event: any) => (paginate(1, filters.value.rows)))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (filters.value.report_type ===  _unref(PrimaryDiagnosisReportTypes).COMORBID)
                        ? (_openBlock(), _createBlock(_unref(Popover), {
                            key: 0,
                            class: "relative"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverButton), null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_unref(UserGroupIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                    _hoisted_14
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_Transition, {
                                "enter-active-class": "transition duration-200 ease-out",
                                "enter-from-class": "translate-y-1 opacity-0",
                                "enter-to-class": "translate-y-0 opacity-100",
                                "leave-active-class": "transition duration-150 ease-in",
                                "leave-from-class": "translate-y-0 opacity-100",
                                "leave-to-class": "translate-y-1 opacity-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _hoisted_17,
                                          _createVNode(RadioGroup, {
                                            options: defaultCategoryOptions,
                                            name: "categoryOptions",
                                            modelValue: filters.value.group_category,
                                            "onUpdate:modelValue": [
                                              _cache[5] || (_cache[5] = ($event: any) => ((filters.value.group_category) = $event)),
                                              _cache[6] || (_cache[6] = ($event: any) => {paginate( 1, 10);})
                                            ]
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "flex px-4 py-3 space-x-2 transition bg-white border rounded cursor-pointer border-neutral-100 hover:bg-primary-100",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (showFilter.value = true))
                      }, [
                        _createVNode(_unref(FunnelIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                        _hoisted_18
                      ]),
                      _createVNode(_unref(Popover), { class: "relative" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(PopoverButton), null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_unref(ArrowsUpDownIcon), { class: "inline-block w-5 h-5 text-neutral-900" }),
                                _hoisted_20
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition duration-200 ease-out",
                            "enter-from-class": "translate-y-1 opacity-0",
                            "enter-to-class": "translate-y-0 opacity-100",
                            "leave-active-class": "transition duration-150 ease-in",
                            "leave-from-class": "translate-y-0 opacity-100",
                            "leave-to-class": "translate-y-1 opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-fit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(RadioGroup, {
                                        options: sampleOptions,
                                        name: "sampleoptions",
                                        modelValue: filters.value.column,
                                        "onUpdate:modelValue": [
                                          _cache[8] || (_cache[8] = ($event: any) => ((filters.value.column) = $event)),
                                          _cache[9] || (_cache[9] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _hoisted_23,
                                    _createElementVNode("div", _hoisted_24, [
                                      _createVNode(RadioGroup, {
                                        options: defaultOptions,
                                        name: "defaultoptions",
                                        modelValue: filters.value.order,
                                        "onUpdate:modelValue": [
                                          _cache[10] || (_cache[10] = ($event: any) => ((filters.value.order) = $event)),
                                          _cache[11] || (_cache[11] = ($event: any) => (getData()))
                                        ]
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[22] || (_cache[22] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[23] || (_cache[23] = ($event: any) => (applyReset())),
                        "onApply:filters": _cache[24] || (_cache[24] = ($event: any) => (applyFilters())),
                        customClass: "!overflow-visible overflow-x-visible"
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            (_ctx.userRole?.id == _unref(RoleTypes).SUPERADMIN || _ctx.userRole?.id == _unref(RoleTypes).SUPERADMIN_IT)
                              ? (_openBlock(), _createBlock(DatePicker, {
                                  key: 0,
                                  id: "date_created",
                                  name: "date_created",
                                  label: "Date Created",
                                  modelValue: filters.value.created_at,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.value.created_at) = $event)),
                                  range: "",
                                  multiCalendars: "",
                                  class: "filter-range"
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true),
                            _createVNode(DatePicker, {
                              id: "date_registered",
                              name: "date_registered",
                              label: "Date Registered",
                              modelValue: filters.value.registered_at,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((filters.value.registered_at) = $event)),
                              range: "",
                              multiCalendars: "",
                              class: "filter-range"
                            }, null, 8, ["modelValue"]),
                            (userData.value?.role_id == _unref(RoleTypes).SUPERADMIN)
                              ? (_openBlock(), _createBlock(MultiSelect, {
                                  key: 1,
                                  options: offices.value,
                                  id: "office_id",
                                  name: "office_id",
                                  label: "Office",
                                  placeholder: "Select..",
                                  modelValue: filters.value.office_id,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((filters.value.office_id) = $event))
                                }, null, 8, ["options", "modelValue"]))
                              : _createCommentVNode("", true),
                            (filters.value.report_type !== _unref(PrimaryDiagnosisReportTypes).COMORBID)
                              ? (_openBlock(), _createBlock(MultiSelect, {
                                  key: 2,
                                  options: diagnosis.value,
                                  id: "diagnosis_id",
                                  name: "diagnosis_id",
                                  label: "Primary Diagnosis",
                                  placeholder: "Select..",
                                  modelValue: filters.value.diagnosis_id,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filters.value.diagnosis_id) = $event))
                                }, null, 8, ["options", "modelValue"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_26, [
                              (
                                                    filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).PROVINCE
                                                    || filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).CITY
                                                    || filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).BARANGAY
                                                    )
                                ? (_openBlock(), _createBlock(MultiSelect, {
                                    key: 0,
                                    options: regions.value,
                                    id: "region_id",
                                    name: "region_id",
                                    label: "Regions",
                                    placeholder: "Select..",
                                    modelValue: filters.value.region_id,
                                    "onUpdate:modelValue": [
                                      _cache[16] || (_cache[16] = ($event: any) => ((filters.value.region_id) = $event)),
                                      _cache[17] || (_cache[17] = ($event: any) => (regionChange()))
                                    ]
                                  }, null, 8, ["options", "modelValue"]))
                                : _createCommentVNode("", true),
                              ( 
                                                    filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).CITY
                                                    || filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).BARANGAY
                                                    )
                                ? (_openBlock(), _createBlock(MultiSelect, {
                                    key: 1,
                                    options: provinces.value,
                                    id: "province_id",
                                    name: "province_id",
                                    label: "Provinces",
                                    placeholder: "Select..",
                                    modelValue: filters.value.province_id,
                                    "onUpdate:modelValue": [
                                      _cache[18] || (_cache[18] = ($event: any) => ((filters.value.province_id) = $event)),
                                      _cache[19] || (_cache[19] = ($event: any) => (provinceChange()))
                                    ]
                                  }, null, 8, ["options", "modelValue"]))
                                : _createCommentVNode("", true),
                              ( 
                                                    filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).BARANGAY 
                                                    )
                                ? (_openBlock(), _createBlock(MultiSelect, {
                                    key: 2,
                                    options: cities.value,
                                    id: "city_id",
                                    name: "city_id",
                                    label: "Cities",
                                    placeholder: "Select..",
                                    modelValue: filters.value.city_id,
                                    "onUpdate:modelValue": [
                                      _cache[20] || (_cache[20] = ($event: any) => ((filters.value.city_id) = $event)),
                                      _cache[21] || (_cache[21] = ($event: any) => (cityChange()))
                                    ]
                                  }, null, 8, ["options", "modelValue"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (filters.value.report_type != _unref(PrimaryDiagnosisReportTypes).COMORBID)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(items.value?.data, (item) => {
                          return (_openBlock(), _createElementBlock("tr", { key: item }, [
                            _createElementVNode("td", _hoisted_27, _toDisplayString(item?.name), 1),
                            _createElementVNode("td", _hoisted_28, _toDisplayString(item?.male_set1), 1),
                            _createElementVNode("td", _hoisted_29, _toDisplayString(item?.female_set1), 1),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(item?.male_set2), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(item?.female_set2), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(item?.male_set3), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(item?.female_set3), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(item?.male_set4), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(item?.female_set4), 1),
                            _createElementVNode("td", _hoisted_36, _toDisplayString(item?.male_set5), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(item?.female_set5), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(item?.male_set6), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(item?.female_set6), 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(item?.children_male), 1),
                            _createElementVNode("td", _hoisted_41, _toDisplayString(item?.children_female), 1),
                            _createElementVNode("td", _hoisted_42, _toDisplayString(item.total_children), 1),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(item?.male_set7), 1),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(item?.female_set7), 1),
                            _createElementVNode("td", _hoisted_45, _toDisplayString(item?.male_set8), 1),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(item?.female_set8), 1),
                            _createElementVNode("td", _hoisted_47, _toDisplayString(item?.male_set9), 1),
                            _createElementVNode("td", _hoisted_48, _toDisplayString(item?.female_set9), 1),
                            _createElementVNode("td", _hoisted_49, _toDisplayString(item?.male_set10), 1),
                            _createElementVNode("td", _hoisted_50, _toDisplayString(item?.female_set10), 1),
                            _createElementVNode("td", _hoisted_51, _toDisplayString(item?.adult_male), 1),
                            _createElementVNode("td", _hoisted_52, _toDisplayString(item?.adult_female), 1),
                            _createElementVNode("td", _hoisted_53, _toDisplayString(item?.total_adultWomen), 1),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(item?.total), 1)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    (filters.value.report_type === _unref(PrimaryDiagnosisReportTypes).COMORBID)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (filters.value.group_category === 1)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(items.value?.data, (item) => {
                                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                  _createElementVNode("td", _hoisted_55, _toDisplayString(item?.name), 1),
                                  _createElementVNode("td", _hoisted_56, _toDisplayString(item?.male_set1), 1),
                                  _createElementVNode("td", _hoisted_57, _toDisplayString(item?.female_set1), 1),
                                  _createElementVNode("td", _hoisted_58, _toDisplayString(item?.male_set2), 1),
                                  _createElementVNode("td", _hoisted_59, _toDisplayString(item?.female_set2), 1),
                                  _createElementVNode("td", _hoisted_60, _toDisplayString(item?.male_set3), 1),
                                  _createElementVNode("td", _hoisted_61, _toDisplayString(item?.female_set3), 1),
                                  _createElementVNode("td", _hoisted_62, _toDisplayString(item?.male_set4), 1),
                                  _createElementVNode("td", _hoisted_63, _toDisplayString(item?.female_set4), 1),
                                  _createElementVNode("td", _hoisted_64, _toDisplayString(item?.male_set5), 1),
                                  _createElementVNode("td", _hoisted_65, _toDisplayString(item?.female_set5), 1),
                                  _createElementVNode("td", _hoisted_66, _toDisplayString(item?.male_set6), 1),
                                  _createElementVNode("td", _hoisted_67, _toDisplayString(item?.female_set6), 1),
                                  _createElementVNode("td", _hoisted_68, _toDisplayString(item?.children_male), 1),
                                  _createElementVNode("td", _hoisted_69, _toDisplayString(item?.children_female), 1),
                                  _createElementVNode("td", _hoisted_70, _toDisplayString(item.total_children), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (filters.value.group_category === 3)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(items.value?.data, (item) => {
                                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                                  _createElementVNode("td", _hoisted_71, _toDisplayString(item?.name), 1),
                                  _createElementVNode("td", _hoisted_72, _toDisplayString(item?.male_set7), 1),
                                  _createElementVNode("td", _hoisted_73, _toDisplayString(item?.female_set7), 1),
                                  _createElementVNode("td", _hoisted_74, _toDisplayString(item?.male_set8), 1),
                                  _createElementVNode("td", _hoisted_75, _toDisplayString(item?.female_set8), 1),
                                  _createElementVNode("td", _hoisted_76, _toDisplayString(item?.male_set9), 1),
                                  _createElementVNode("td", _hoisted_77, _toDisplayString(item?.female_set9), 1),
                                  _createElementVNode("td", _hoisted_78, _toDisplayString(item?.male_set10), 1),
                                  _createElementVNode("td", _hoisted_79, _toDisplayString(item?.female_set10), 1),
                                  _createElementVNode("td", _hoisted_80, _toDisplayString(item?.adult_male), 1),
                                  _createElementVNode("td", _hoisted_81, _toDisplayString(item?.adult_female), 1),
                                  _createElementVNode("td", _hoisted_82, _toDisplayString(item?.total_adultWomen), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", _hoisted_83, [
                      _hoisted_84,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totals.value, (total, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: index,
                          class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap"
                        }, _toDisplayString(total), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["headers", "count", "search"]),
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(SimplePagination, {
                    numRows: filters.value.rows,
                    currentPage: items.value?.current_page,
                    "last-page": items.value?.last_page,
                    onUpdate: _cache[26] || (_cache[26] = (value) => paginate(value.page, value.rows))
                  }, null, 8, ["numRows", "currentPage", "last-page"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(LoadingModal, {
        show: loading.value,
        noBtn: "",
        title: "Please wait..",
        content: "System is currently loading the report based on the selected filter."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})